import { render } from "./eventDetail.vue?vue&type=template&id=924d02cc&scoped=true"
import script from "./eventDetail.vue?vue&type=script&lang=js"
export * from "./eventDetail.vue?vue&type=script&lang=js"

import "./eventDetail.vue?vue&type=style&index=0&id=924d02cc&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-924d02cc"]])

export default __exports__